function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImportantIcon from "@material-ui/icons/LabelImportant";
import CommentsIcon from "@material-ui/icons/Forum";
import Typography from '@material-ui/core/Typography';
import UserIcon from "../User/UserIcon"; //import InboxIcon from "./InboxIcon"

import getInboxModule from "./utils/getInboxModule";
const useStyles = makeStyles(theme => ({
  root: {
    display: "block",
    width: "100%",
    position: "relative",
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(2),
    userSelect: "none",
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: theme.spacing(4.5),
    height: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2)
  },
  icon: {
    fontSize: "18px",
    color: props => {
      return props.color || "rgba(0,0,0,.25)";
    }
  },
  authors: {
    marginLeft: theme.spacing(.5),
    marginRight: theme.spacing(.5),
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px"
  },
  name: {
    "&[data-unread=true]": {
      fontWeight: "bold"
    }
  },
  count: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "12px"
  }
}));

const InboxAuthor = ({
  unread,
  shortName,
  name,
  size
}) => {
  const classes = useStyles();

  if (size === "small") {
    return React.createElement("b", {
      className: classes.name,
      "data-unread": unread
    }, shortName);
  }

  return React.createElement("b", {
    className: classes.name,
    "data-unread": unread
  }, name);
};

const InboxAuthors = ({
  authors = []
}) => {
  const classes = useStyles();

  if (!authors.length) {
    return false;
  }

  if (authors.length > 2) {
    return React.createElement(Typography, {
      noWrap: true,
      className: classes.authors
    }, React.createElement(InboxAuthor, _extends({}, authors[0], {
      size: "small"
    })), "...", React.createElement(InboxAuthor, _extends({}, authors[authors.length - 1], {
      size: "small"
    })));
  }

  if (authors.length === 2) {
    return React.createElement(Typography, {
      noWrap: true,
      className: classes.authors
    }, React.createElement(InboxAuthor, _extends({}, authors[0], {
      size: "small"
    })), ",", React.createElement(InboxAuthor, _extends({}, authors[authors.length - 1], {
      size: "small"
    })));
  }

  return React.createElement(Typography, {
    noWrap: true,
    className: classes.authors
  }, React.createElement(InboxAuthor, authors[0]));
};

const InboxIcon = ({
  inboxType,
  important,
  appColor
}) => {
  let color = "#ccc";

  if (important) {
    color = "orange" || appColor;
  }

  const classes = useStyles({
    color
  });

  if (inboxType === "comment" || inboxType === "forum") {
    return React.createElement(CommentsIcon, {
      className: classes.icon
    });
  }

  return React.createElement(ImportantIcon, {
    className: classes.icon
  });
};

const InboxModuleHeader = (_ref) => {
  let className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  const _getInboxModule = getInboxModule(props),
        appColor = _getInboxModule.appColor,
        important = _getInboxModule.important,
        author = _getInboxModule.author,
        authors = _getInboxModule.authors,
        messagesCount = _getInboxModule.messagesCount;

  const classes = useStyles();
  return React.createElement("header", {
    className: className || classes.root
  }, React.createElement(UserIcon, _extends({}, author, {
    className: classes.avatar
  })), React.createElement(InboxIcon, _extends({}, props, {
    className: classes.icon
  })), React.createElement(InboxAuthors, {
    authors: authors
  }), React.createElement("i", {
    className: classes.count
  }, messagesCount));
};

export default InboxModuleHeader;